/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DisciplineCategoryEnum,
    DisciplineCategoryEnumFromJSON,
    DisciplineCategoryEnumFromJSONTyped,
    DisciplineCategoryEnumToJSON,
} from './DisciplineCategoryEnum';
import {
    EvaluationTypeEnum,
    EvaluationTypeEnumFromJSON,
    EvaluationTypeEnumFromJSONTyped,
    EvaluationTypeEnumToJSON,
} from './EvaluationTypeEnum';
import {
    GradingTypeEnum,
    GradingTypeEnumFromJSON,
    GradingTypeEnumFromJSONTyped,
    GradingTypeEnumToJSON,
} from './GradingTypeEnum';
import {
    IndicatorTypeEnum,
    IndicatorTypeEnumFromJSON,
    IndicatorTypeEnumFromJSONTyped,
    IndicatorTypeEnumToJSON,
} from './IndicatorTypeEnum';
import {
    SemesterTypeEnum,
    SemesterTypeEnumFromJSON,
    SemesterTypeEnumFromJSONTyped,
    SemesterTypeEnumToJSON,
} from './SemesterTypeEnum';
import {
    StudyYearEnum,
    StudyYearEnumFromJSON,
    StudyYearEnumFromJSONTyped,
    StudyYearEnumToJSON,
} from './StudyYearEnum';
import {
    SubjectContent,
    SubjectContentFromJSON,
    SubjectContentFromJSONTyped,
    SubjectContentToJSON,
} from './SubjectContent';
import {
    SubjectEvaluation,
    SubjectEvaluationFromJSON,
    SubjectEvaluationFromJSONTyped,
    SubjectEvaluationToJSON,
} from './SubjectEvaluation';
import {
    SubjectLearningOutcome,
    SubjectLearningOutcomeFromJSON,
    SubjectLearningOutcomeFromJSONTyped,
    SubjectLearningOutcomeToJSON,
} from './SubjectLearningOutcome';

/**
 * 
 * @export
 * @interface AddSubjectFileDTO
 */
export interface AddSubjectFileDTO {
    /**
     * 
     * @type {number}
     * @memberof AddSubjectFileDTO
     */
    orderNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof AddSubjectFileDTO
     */
    nameRO?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddSubjectFileDTO
     */
    nameEN?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddSubjectFileDTO
     */
    departmentId?: string;
    /**
     * 
     * @type {SemesterTypeEnum}
     * @memberof AddSubjectFileDTO
     */
    semester?: SemesterTypeEnum;
    /**
     * 
     * @type {StudyYearEnum}
     * @memberof AddSubjectFileDTO
     */
    studyYear?: StudyYearEnum;
    /**
     * 
     * @type {number}
     * @memberof AddSubjectFileDTO
     */
    schoolYear?: number;
    /**
     * 
     * @type {number}
     * @memberof AddSubjectFileDTO
     */
    planYear?: number;
    /**
     * 
     * @type {string}
     * @memberof AddSubjectFileDTO
     */
    studyProgramId?: string;
    /**
     * 
     * @type {EvaluationTypeEnum}
     * @memberof AddSubjectFileDTO
     */
    evaluationType?: EvaluationTypeEnum;
    /**
     * 
     * @type {IndicatorTypeEnum}
     * @memberof AddSubjectFileDTO
     */
    subjectType?: IndicatorTypeEnum;
    /**
     * 
     * @type {IndicatorTypeEnum}
     * @memberof AddSubjectFileDTO
     */
    subjectCategory?: IndicatorTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AddSubjectFileDTO
     */
    code?: string | null;
    /**
     * 
     * @type {GradingTypeEnum}
     * @memberof AddSubjectFileDTO
     */
    gradingType?: GradingTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AddSubjectFileDTO
     */
    totalWeeklyHours?: number;
    /**
     * 
     * @type {number}
     * @memberof AddSubjectFileDTO
     */
    courseWeeklyHours?: number;
    /**
     * 
     * @type {number}
     * @memberof AddSubjectFileDTO
     */
    labWeeklyHours?: number;
    /**
     * 
     * @type {number}
     * @memberof AddSubjectFileDTO
     */
    seminarWeeklyHours?: number;
    /**
     * 
     * @type {number}
     * @memberof AddSubjectFileDTO
     */
    practiceWeeklyHours?: number;
    /**
     * 
     * @type {number}
     * @memberof AddSubjectFileDTO
     */
    projectWeeklyHours?: number;
    /**
     * 
     * @type {number}
     * @memberof AddSubjectFileDTO
     */
    totalHours?: number;
    /**
     * 
     * @type {number}
     * @memberof AddSubjectFileDTO
     */
    courseHours?: number;
    /**
     * 
     * @type {number}
     * @memberof AddSubjectFileDTO
     */
    labHours?: number;
    /**
     * 
     * @type {number}
     * @memberof AddSubjectFileDTO
     */
    selfStudyHours?: number;
    /**
     * 
     * @type {number}
     * @memberof AddSubjectFileDTO
     */
    tutoringHours?: number;
    /**
     * 
     * @type {number}
     * @memberof AddSubjectFileDTO
     */
    examHours?: number;
    /**
     * 
     * @type {number}
     * @memberof AddSubjectFileDTO
     */
    otherActivitiesHours?: number;
    /**
     * 
     * @type {number}
     * @memberof AddSubjectFileDTO
     */
    totalSelfStudyHours?: number;
    /**
     * 
     * @type {number}
     * @memberof AddSubjectFileDTO
     */
    totalSemesterHours?: number;
    /**
     * 
     * @type {number}
     * @memberof AddSubjectFileDTO
     */
    credits?: number;
    /**
     * 
     * @type {number}
     * @memberof AddSubjectFileDTO
     */
    creditsIIS?: number;
    /**
     * 
     * @type {number}
     * @memberof AddSubjectFileDTO
     */
    creditsOE?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AddSubjectFileDTO
     */
    labAtPartner?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddSubjectFileDTO
     */
    seminarAtPartner?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddSubjectFileDTO
     */
    projectAtPartner?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddSubjectFileDTO
     */
    practiceAtPartner?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AddSubjectFileDTO
     */
    curriculumPrecondition?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddSubjectFileDTO
     */
    respultsPrecondition?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddSubjectFileDTO
     */
    courseConditions?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddSubjectFileDTO
     */
    labConditions?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddSubjectFileDTO
     */
    generalObjective?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddSubjectFileDTO
     */
    specificCompetence?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddSubjectFileDTO
     */
    generalCompetence?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddSubjectFileDTO
     */
    teachingKnowledges?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddSubjectFileDTO
     */
    teachingAptitudes?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddSubjectFileDTO
     */
    teachingResponsabilities?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddSubjectFileDTO
     */
    teachingMethods?: string | null;
    /**
     * 
     * @type {Array<SubjectContent>}
     * @memberof AddSubjectFileDTO
     */
    subjectContents?: Array<SubjectContent> | null;
    /**
     * 
     * @type {string}
     * @memberof AddSubjectFileDTO
     */
    courseBibliography?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddSubjectFileDTO
     */
    labBibliography?: string | null;
    /**
     * 
     * @type {Array<SubjectEvaluation>}
     * @memberof AddSubjectFileDTO
     */
    subjectEvaluations?: Array<SubjectEvaluation> | null;
    /**
     * 
     * @type {Array<SubjectLearningOutcome>}
     * @memberof AddSubjectFileDTO
     */
    learningOutcomes?: Array<SubjectLearningOutcome> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddSubjectFileDTO
     */
    minimumPromotionOutcomeIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AddSubjectFileDTO
     */
    promotionConditions?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddSubjectFileDTO
     */
    subjectCoroboration?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddSubjectFileDTO
     */
    courseCoordinatorIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddSubjectFileDTO
     */
    labCoordinatorIds?: Array<string> | null;
    /**
     * 
     * @type {DisciplineCategoryEnum}
     * @memberof AddSubjectFileDTO
     */
    disciplineCategory?: DisciplineCategoryEnum;
    /**
     * 
     * @type {number}
     * @memberof AddSubjectFileDTO
     */
    practiceTotalHours?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AddSubjectFileDTO
     */
    isPartiallySaved?: boolean;
}

export function AddSubjectFileDTOFromJSON(json: any): AddSubjectFileDTO {
    return AddSubjectFileDTOFromJSONTyped(json, false);
}

export function AddSubjectFileDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddSubjectFileDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orderNumber': !exists(json, 'orderNumber') ? undefined : json['orderNumber'],
        'nameRO': !exists(json, 'nameRO') ? undefined : json['nameRO'],
        'nameEN': !exists(json, 'nameEN') ? undefined : json['nameEN'],
        'departmentId': !exists(json, 'departmentId') ? undefined : json['departmentId'],
        'semester': !exists(json, 'semester') ? undefined : SemesterTypeEnumFromJSON(json['semester']),
        'studyYear': !exists(json, 'studyYear') ? undefined : StudyYearEnumFromJSON(json['studyYear']),
        'schoolYear': !exists(json, 'schoolYear') ? undefined : json['schoolYear'],
        'planYear': !exists(json, 'planYear') ? undefined : json['planYear'],
        'studyProgramId': !exists(json, 'studyProgramId') ? undefined : json['studyProgramId'],
        'evaluationType': !exists(json, 'evaluationType') ? undefined : EvaluationTypeEnumFromJSON(json['evaluationType']),
        'subjectType': !exists(json, 'subjectType') ? undefined : IndicatorTypeEnumFromJSON(json['subjectType']),
        'subjectCategory': !exists(json, 'subjectCategory') ? undefined : IndicatorTypeEnumFromJSON(json['subjectCategory']),
        'code': !exists(json, 'code') ? undefined : json['code'],
        'gradingType': !exists(json, 'gradingType') ? undefined : GradingTypeEnumFromJSON(json['gradingType']),
        'totalWeeklyHours': !exists(json, 'totalWeeklyHours') ? undefined : json['totalWeeklyHours'],
        'courseWeeklyHours': !exists(json, 'courseWeeklyHours') ? undefined : json['courseWeeklyHours'],
        'labWeeklyHours': !exists(json, 'labWeeklyHours') ? undefined : json['labWeeklyHours'],
        'seminarWeeklyHours': !exists(json, 'seminarWeeklyHours') ? undefined : json['seminarWeeklyHours'],
        'practiceWeeklyHours': !exists(json, 'practiceWeeklyHours') ? undefined : json['practiceWeeklyHours'],
        'projectWeeklyHours': !exists(json, 'projectWeeklyHours') ? undefined : json['projectWeeklyHours'],
        'totalHours': !exists(json, 'totalHours') ? undefined : json['totalHours'],
        'courseHours': !exists(json, 'courseHours') ? undefined : json['courseHours'],
        'labHours': !exists(json, 'labHours') ? undefined : json['labHours'],
        'selfStudyHours': !exists(json, 'selfStudyHours') ? undefined : json['selfStudyHours'],
        'tutoringHours': !exists(json, 'tutoringHours') ? undefined : json['tutoringHours'],
        'examHours': !exists(json, 'examHours') ? undefined : json['examHours'],
        'otherActivitiesHours': !exists(json, 'otherActivitiesHours') ? undefined : json['otherActivitiesHours'],
        'totalSelfStudyHours': !exists(json, 'totalSelfStudyHours') ? undefined : json['totalSelfStudyHours'],
        'totalSemesterHours': !exists(json, 'totalSemesterHours') ? undefined : json['totalSemesterHours'],
        'credits': !exists(json, 'credits') ? undefined : json['credits'],
        'creditsIIS': !exists(json, 'creditsIIS') ? undefined : json['creditsIIS'],
        'creditsOE': !exists(json, 'creditsOE') ? undefined : json['creditsOE'],
        'labAtPartner': !exists(json, 'labAtPartner') ? undefined : json['labAtPartner'],
        'seminarAtPartner': !exists(json, 'seminarAtPartner') ? undefined : json['seminarAtPartner'],
        'projectAtPartner': !exists(json, 'projectAtPartner') ? undefined : json['projectAtPartner'],
        'practiceAtPartner': !exists(json, 'practiceAtPartner') ? undefined : json['practiceAtPartner'],
        'curriculumPrecondition': !exists(json, 'curriculumPrecondition') ? undefined : json['curriculumPrecondition'],
        'respultsPrecondition': !exists(json, 'respultsPrecondition') ? undefined : json['respultsPrecondition'],
        'courseConditions': !exists(json, 'courseConditions') ? undefined : json['courseConditions'],
        'labConditions': !exists(json, 'labConditions') ? undefined : json['labConditions'],
        'generalObjective': !exists(json, 'generalObjective') ? undefined : json['generalObjective'],
        'specificCompetence': !exists(json, 'specificCompetence') ? undefined : json['specificCompetence'],
        'generalCompetence': !exists(json, 'generalCompetence') ? undefined : json['generalCompetence'],
        'teachingKnowledges': !exists(json, 'teachingKnowledges') ? undefined : json['teachingKnowledges'],
        'teachingAptitudes': !exists(json, 'teachingAptitudes') ? undefined : json['teachingAptitudes'],
        'teachingResponsabilities': !exists(json, 'teachingResponsabilities') ? undefined : json['teachingResponsabilities'],
        'teachingMethods': !exists(json, 'teachingMethods') ? undefined : json['teachingMethods'],
        'subjectContents': !exists(json, 'subjectContents') ? undefined : (json['subjectContents'] === null ? null : (json['subjectContents'] as Array<any>).map(SubjectContentFromJSON)),
        'courseBibliography': !exists(json, 'courseBibliography') ? undefined : json['courseBibliography'],
        'labBibliography': !exists(json, 'labBibliography') ? undefined : json['labBibliography'],
        'subjectEvaluations': !exists(json, 'subjectEvaluations') ? undefined : (json['subjectEvaluations'] === null ? null : (json['subjectEvaluations'] as Array<any>).map(SubjectEvaluationFromJSON)),
        'learningOutcomes': !exists(json, 'learningOutcomes') ? undefined : (json['learningOutcomes'] === null ? null : (json['learningOutcomes'] as Array<any>).map(SubjectLearningOutcomeFromJSON)),
        'minimumPromotionOutcomeIds': !exists(json, 'minimumPromotionOutcomeIds') ? undefined : json['minimumPromotionOutcomeIds'],
        'promotionConditions': !exists(json, 'promotionConditions') ? undefined : json['promotionConditions'],
        'subjectCoroboration': !exists(json, 'subjectCoroboration') ? undefined : json['subjectCoroboration'],
        'courseCoordinatorIds': !exists(json, 'courseCoordinatorIds') ? undefined : json['courseCoordinatorIds'],
        'labCoordinatorIds': !exists(json, 'labCoordinatorIds') ? undefined : json['labCoordinatorIds'],
        'disciplineCategory': !exists(json, 'disciplineCategory') ? undefined : DisciplineCategoryEnumFromJSON(json['disciplineCategory']),
        'practiceTotalHours': !exists(json, 'practiceTotalHours') ? undefined : json['practiceTotalHours'],
        'isPartiallySaved': !exists(json, 'isPartiallySaved') ? undefined : json['isPartiallySaved'],
    };
}

export function AddSubjectFileDTOToJSON(value?: AddSubjectFileDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'orderNumber': value.orderNumber,
        'nameRO': value.nameRO,
        'nameEN': value.nameEN,
        'departmentId': value.departmentId,
        'semester': SemesterTypeEnumToJSON(value.semester),
        'studyYear': StudyYearEnumToJSON(value.studyYear),
        'schoolYear': value.schoolYear,
        'planYear': value.planYear,
        'studyProgramId': value.studyProgramId,
        'evaluationType': EvaluationTypeEnumToJSON(value.evaluationType),
        'subjectType': IndicatorTypeEnumToJSON(value.subjectType),
        'subjectCategory': IndicatorTypeEnumToJSON(value.subjectCategory),
        'code': value.code,
        'gradingType': GradingTypeEnumToJSON(value.gradingType),
        'totalWeeklyHours': value.totalWeeklyHours,
        'courseWeeklyHours': value.courseWeeklyHours,
        'labWeeklyHours': value.labWeeklyHours,
        'seminarWeeklyHours': value.seminarWeeklyHours,
        'practiceWeeklyHours': value.practiceWeeklyHours,
        'projectWeeklyHours': value.projectWeeklyHours,
        'totalHours': value.totalHours,
        'courseHours': value.courseHours,
        'labHours': value.labHours,
        'selfStudyHours': value.selfStudyHours,
        'tutoringHours': value.tutoringHours,
        'examHours': value.examHours,
        'otherActivitiesHours': value.otherActivitiesHours,
        'totalSelfStudyHours': value.totalSelfStudyHours,
        'totalSemesterHours': value.totalSemesterHours,
        'credits': value.credits,
        'creditsIIS': value.creditsIIS,
        'creditsOE': value.creditsOE,
        'labAtPartner': value.labAtPartner,
        'seminarAtPartner': value.seminarAtPartner,
        'projectAtPartner': value.projectAtPartner,
        'practiceAtPartner': value.practiceAtPartner,
        'curriculumPrecondition': value.curriculumPrecondition,
        'respultsPrecondition': value.respultsPrecondition,
        'courseConditions': value.courseConditions,
        'labConditions': value.labConditions,
        'generalObjective': value.generalObjective,
        'specificCompetence': value.specificCompetence,
        'generalCompetence': value.generalCompetence,
        'teachingKnowledges': value.teachingKnowledges,
        'teachingAptitudes': value.teachingAptitudes,
        'teachingResponsabilities': value.teachingResponsabilities,
        'teachingMethods': value.teachingMethods,
        'subjectContents': value.subjectContents === undefined ? undefined : (value.subjectContents === null ? null : (value.subjectContents as Array<any>).map(SubjectContentToJSON)),
        'courseBibliography': value.courseBibliography,
        'labBibliography': value.labBibliography,
        'subjectEvaluations': value.subjectEvaluations === undefined ? undefined : (value.subjectEvaluations === null ? null : (value.subjectEvaluations as Array<any>).map(SubjectEvaluationToJSON)),
        'learningOutcomes': value.learningOutcomes === undefined ? undefined : (value.learningOutcomes === null ? null : (value.learningOutcomes as Array<any>).map(SubjectLearningOutcomeToJSON)),
        'minimumPromotionOutcomeIds': value.minimumPromotionOutcomeIds,
        'promotionConditions': value.promotionConditions,
        'subjectCoroboration': value.subjectCoroboration,
        'courseCoordinatorIds': value.courseCoordinatorIds,
        'labCoordinatorIds': value.labCoordinatorIds,
        'disciplineCategory': DisciplineCategoryEnumToJSON(value.disciplineCategory),
        'practiceTotalHours': value.practiceTotalHours,
        'isPartiallySaved': value.isPartiallySaved,
    };
}

